export enum FaqTypeEnum {
  MoneyStepCounterpartConfirmation = 'money-step-counterpart-confirmation',
  MoneyStepCounterpart = 'money-step-counterpart',
  MoneyStepContactModeSelection = 'money-step-contact-mode-selection',
  MoneyStepDashboard = 'money-step-dashboard',
  MoneyStepDashboardPostOrder = 'money-step-dashboard-post-order',
  MoneyStepSuggestionsSelection = 'money-step-suggestions-selection',
  MoneyStepToBeStarted = 'money-step-to-be-started',
  MoneyStepPromise = 'money-step-promise',
}

export interface ThemedFaqRawResponse {
  data: FaqRawData;
  meta: MetaPagination;
}

export interface FaqRawData {
  id: number;
  attributes: FaqRawDataAttributes;
}

export interface FaqRawDataAttributes {
  feature?: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  locale: string;
  faq_articles: FaqArticles;
}

export interface FaqArticles {
  data: FaqArticlesData[];
}

export interface FaqArticlesData {
  id: number;
  attributes: ThemedFaqItem;
}

export interface ThemedFaqItem {
  id?: string;
  title: string;
  slug?: string;
  highlighted: boolean;
  description: string;
  keywords?: string | string[];
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  locale: string;
  feature?: string;
}

export interface MetaPagination {
  pagination: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  };
}

export const fromFaqRawResponseToThemedFaqItems = (response: ThemedFaqRawResponse): ThemedFaqItem[] => {
  return response.data.attributes.faq_articles.data.map(
    (response) =>
      ({
        id: response.id,
        ...response.attributes,
      }) as ThemedFaqItem
  );
};
